import * as React from 'react';

import {ClassNameBuilder} from '../../utils/ClassNameBuilder';

import * as Styles from './Image.module.scss';

interface Props {
    /**
     * Source of the image.
     */
    src: string;

    /**
     * Optional CSS classes to apply to the image div.
     */
    className?: string;

    /**
     * Function to be executed when the image is clicked.
     */
    onClick?: (event: React.MouseEvent) => void;

    /**
     * Optional accessibility title to add to the div.
     */
    title?: string;
}

/**
 * Renders an image as a background of a div.
 */
export const Image: React.FC<Props> = React.memo((props) => {
    const {className = '', src, title, onClick} = props;
    const classes = new ClassNameBuilder(Styles, 'image', [className, !!className])
        .add(['click', !!onClick]);

    const style: React.CSSProperties = {
        backgroundImage: `url(${src})`
    };

    return (
        <div title={title} className={classes.toString()} style={style} onClick={onClick}></div>
    );
});
